import vRange from './Range.vue';

export { vRange }



// WEBPACK FOOTER //
// ./src/baseComponents/components/Range/index.js